import EmptyStateImage from '../../assets/empty_state.png'
import styles from './InsightsEmptyState.module.scss'
import { type FC, type ReactNode } from 'react'

interface InsightsEmptyStateProps {
  title?: string
  subtitle?: ReactNode
}

export const InsightsEmptyState: FC<InsightsEmptyStateProps> = ({
  title = 'No meetings captured in this period',
  subtitle = 'Try selecting a wider time range',
}) => {
  return (
    <div className={styles.container}>
      <img src={EmptyStateImage} alt='' className={styles.image} />
      <div>
        <h5 className={styles.title}>{title}</h5>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
    </div>
  )
}
